/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_ComplaintInputs */

const en_privacy_section_7_complaint = /** @type {(inputs: Privacy_Section_7_ComplaintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You also have the right to lodge a complaint with the Latvian Data State Inspectorate (Datu valsts inspekcija), Elijas iela 17, Riga, LV-1050, pasts@dvi.gov.lv.`)
};

const lv_privacy_section_7_complaint = /** @type {(inputs: Privacy_Section_7_ComplaintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jums ir arī tiesības iesniegt sūdzību Datu valsts inspekcijā, Elijas ielā 17, Rīgā, LV-1050, pasts@dvi.gov.lv.`)
};

/**
* | output |
* | --- |
* | "You also have the right to lodge a complaint with the Latvian Data State Inspectorate (Datu valsts inspekcija), Elijas iela 17, Riga, LV-1050, pasts@dvi.gov.lv." |
*
* @param {Privacy_Section_7_ComplaintInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_complaint = /** @type {((inputs?: Privacy_Section_7_ComplaintInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_ComplaintInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_complaint(inputs)
	return en_privacy_section_7_complaint(inputs)
});